import { useEffect, useState } from "react";

export function useClientEnv<K extends keyof typeof window.ENV>(
  key: K,
  defaultValue: (typeof window.ENV)[K],
) {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(window.ENV[key]);
  }, [key]);

  return value;
}
